export const UNITY_CONTEXT_INITIALIZED = 'UNITY_CONTEXT_INITIALIZED';
export const UNITY_SET_MODE = 'UNITY_SET_MODE';
export const UNITY_SET_SCENE = 'UNITY_SET_SCENE';
export const UNITY_ADD_COMMAND = 'UNITY_ADD_COMMAND';
export const UNITY_SET_VISIBLE = 'UNITY_SET_VISIBLE';
export const UNITY_SET_LOADING = 'UNITY_SET_LOADING';
export const UNITY_SET_LOADING_PROGRESS = 'UNITY_SET_LOADING_PROGRESS';
export const UNITY_SET_INITIALIZED = 'UNITY_SET_INITIALIZED';

export const UNITY_MODE_WEBGL = 'UNITY_MODE_WEBGL';
export const UNITY_MODE_CONSOLE = 'UNITY_MODE_CONSOLE';

export const VALID_UNITY_MODES = [UNITY_MODE_WEBGL, UNITY_MODE_CONSOLE];
